import type { IEmployeeApiPort } from '@personnel/application/ports/IEmployeeApiPort';
import type { EmployeeDto, EmployeeUpdateDto } from '@personnel/application/dtos/EmployeeResponseDto';
import { errorAttributes, perLog } from '@personnel/application/observability';

/**
 * Use Case for updating an existing employee
 *
 * `per.intent` is what tells the three buttons of the form apart: they are all this same write, so
 * without it there is no way to count how many invitations get resent by hand.
 *
 * @param {Object} props - Use case dependencies
 * @param {IEmployeeApiPort} props.apiPort - Port for API operations
 * @returns {Object} Use case executor with execute method
 */
export const updateEmployeeUseCase = (props: { apiPort: IEmployeeApiPort }) => {
  const { apiPort } = props;

  const execute = async (request: EmployeeUpdateDto): Promise<EmployeeDto> => {
    const attributes = {
      'per.intent': request.intent,
      'per.emailChanged': request.emailChanged,
      'per.roleChanged': request.roleChanged,
    };

    try {
      const updated = await apiPort.updateEmployee(request);

      perLog.info('employeeUpdated', attributes);

      return updated;
    } catch (error) {
      perLog.error('employeeUpdated', { ...attributes, ...errorAttributes(error) });
      throw error;
    }
  };

  return { execute };
};
